export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 2;
export const RES_PER_PAGE = 10;
export const KEY = '644da62b-5ae8-4f32-8c9d-4a97c56cbfc9';
export const MODAL_CLOSE_SEC = 2.5;
